<template>
  <div class="alert">
    <span v-html="props.text"></span>
  </div>
</template>

<script setup>
const props = defineProps(['text'])
</script>

<style scoped>
.alert {
  position: fixed;
  right: 20px;
  bottom: 20px;
  width: auto;
  height: auto;
  padding: 20px 40px;
  background-color: #fff;
  border-radius: 10px;
  z-index: 999999;
  box-shadow: 0 1px 6px rgba(0, 0, 0, .15);
}
</style>